import type { DummyFoods } from './dummyFoods'

export const ribs: DummyFoods = {
  Ribs: {
    Beef: {
      Cooked: ['Ribs (cooked)'],
      Raw: ['Ribs (raw)'],
    },
    Lamb: {
      Cooked: ['Lamb ribs (cooked)'],
      Raw: ['Lamb ribs (raw)'],
    },
    Pork: {
      Cooked: ['Pork ribs (cooked)'],
      Raw: ['Pork ribs (raw)'],
    },
  },
}
